import {
  DeleteOutlined,
  EyeOutlined,
  PlusOutlined,
  EnterOutlined
} from "@ant-design/icons";
import {
  Button,
  Divider,
  Image,
  Modal,
  Spin,
  Popover,
  notification,
  Upload
} from "antd";
import { UploadFile } from "antd/es/upload/interface";
import React, { useEffect, useMemo, useState } from "react";
import { RandomUtil } from "../../../utils";
import { CurrencyUploadProps } from "../../base/currency-upload";
import { useIsPermission } from "../../../hooks";
import { WebStorageUtil } from "../../../utils/webStorage";
import { ReduxActionType } from "../../../constants";
import { API_OTHER } from "../../../api/API_OTHER";
import "./index.less";
import { API_SYS } from "../../../api";
import { useQuery } from "../../../hooks/useQuery";
import { log } from "console";
import { request } from "../../../utils";

export function UploadImage(props: UploadImageProps) {
  const {
    value = [],
    onChange,
    maxCount = Infinity,
    permissions,
    defaultValue,
    ...rest
  } = props;
  const query = useQuery();

  const isPermission = useIsPermission(permissions ? permissions : []);
  const [fileList, setFileList] = useState<UploadFile[]>();
  const [visible, setVisible] = useState<any>();
  const [qrUrl, setQrUrl] = useState<any>();
  const [confirmLoading, setConfirmLoading] = useState<boolean>(false);
  const [sentKey, setSentKey] = useState<any>();

  useEffect(() => {
    console.log(qrUrl);
  }, [visible]);

  const list = useMemo<UploadFile[]>(() => {
    if (!fileList?.length && value) {
      console.log(1);
      if (value.length) {
        console.log(2);
        return value.map((item) => ({
          uid: RandomUtil.createRandomKey(5),
          path: item.url,
          url: item.url,
          size: 0,
          status: item.status,
          type: "image/*"
        })) as any;
      } else {
        console.log(3);
        return fileList;
      }
    } else if (!value.length) {
      console.log(4);
      return [];
    }
    console.log(5);
    return fileList;
  }, [fileList, value]);
  useEffect(() => {
    setFileList([]);
  }, [query]);
  const [isError, setIsError] = useState<boolean>(false);
  useEffect(() => {
    if (isError) {
      setTimeout(() => {
        setIsError(false);
      }, 2000);
    }
  }, [isError]);
  return (
    <>
      <Image.PreviewGroup>
        <Upload
          nowType="image"
          fileList={list}
          multiple={true}
          maxCount={50}
          accept="image/*"
          beforeUpload={(file) => {
            let fileSize = file.size / 1024 / 1024;
            if (fileSize > 2) {
              try {
                return new Promise((resolve) => {
                  //声明FileReader文件读取对象
                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = () => {
                    // 生成canvas画布
                    const canvas = document.createElement("canvas");
                    // 生成img
                    const img = document.createElement("img");
                    //@ts-ignore
                    img.src = reader.result;
                    img.onload = () => {
                      const ctx = canvas.getContext("2d");
                      //原始图片宽度、高度
                      let originImageWidth = img.width,
                        originImageHeight = img.height;
                      //默认最大尺度的尺寸限制在（1920 * 1080）
                      let maxWidth = 1920,
                        maxHeight = 1080,
                        ratio = maxWidth / maxHeight;
                      //目标尺寸
                      let targetWidth = originImageWidth,
                        targetHeight = originImageHeight;

                      canvas.width = targetWidth;
                      canvas.height = targetHeight;
                      // 清除画布
                      //@ts-ignore
                      ctx.clearRect(0, 0, targetWidth, targetHeight);
                      // 绘制图片
                      //@ts-ignore
                      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                      // quality值越小,图像越模糊,默认图片质量为0.92
                      const imageDataURL = canvas.toDataURL(
                        file.type || "image/jpeg",
                        0.85
                      );
                      // 去掉URL的头,并转换为byte
                      const imageBytes = window.atob(
                        imageDataURL.split(",")[1]
                      );
                      // 处理异常,将ascii码小于0的转换为大于0
                      const arrayBuffer = new ArrayBuffer(imageBytes.length);
                      const uint8Array = new Uint8Array(arrayBuffer);
                      for (let i = 0; i < imageBytes.length; i++) {
                        uint8Array[i] = imageBytes.charCodeAt(i);
                      }
                      //@ts-ignore
                      let mimeType = imageDataURL
                        .split(",")[0]
                        .match(/:(.*?);/)[1];
                      let newFile = new File([uint8Array], file.name, {
                        type: mimeType || "image/jpeg"
                      });

                      resolve(newFile);
                    };
                  };
                  reader.onerror = () => {
                    return file;
                  };
                });
              } catch (e) {
                //压缩出错,直接返回原file对象
                return file;
              }
            }
            return file;
          }}
          itemRender={(originNode, file, fileList) => {
            if (file.status == "done") {
              return (
                <div className="ant-upload-list-item ant-upload-list-item-undefined ant-upload-list-item-list-type-picture-card">
                  <div
                    style={{
                      overflow: "hidden",
                      height: "100%"
                    }}
                  >
                    <Image
                      style={{ width: 86, height: 86 }}
                      src={
                        //@ts-ignore
                        file?.response?.data
                          ? file?.response?.data +
                            "?x-oss-process=image/resize,m_fixed,h_86,w_86"
                          : file.url +
                            "?x-oss-process=image/resize,m_fixed,h_86,w_86"
                      }
                      onError={() => {
                        console.log(132323);
                        if (onChange && typeof onChange === "function") {
                          // @ts-ignore
                          let result: any = list.map(
                            // @ts-ignore
                            (item) => {
                              if (item.uid == file.uid) {
                                return {
                                  ...item,
                                  status: "error"
                                };
                              } else {
                                return item;
                              }
                            }
                          );
                          onChange(result);
                          setFileList(result);
                        }
                      }}
                      preview={{
                        //@ts-ignore
                        src: file?.response?.data
                          ? file?.response?.data
                          : file.url,
                        mask: (
                          <div className="ant-upload-list-item-actions">
                            <Button type="text" icon={<EyeOutlined />} />
                            <Button
                              type="text"
                              style={{ color: "white" }}
                              icon={<EnterOutlined />}
                              onClick={(e) => {
                                e.stopPropagation();
                                let result: any = [];
                                list.map(
                                  // @ts-ignore
                                  (item) => {
                                    if (item.uid !== file.uid) {
                                      result.push({
                                        // @ts-ignore
                                        url: item?.response?.data
                                          ? item?.response?.data
                                          : item.url,
                                        status: "done"
                                      });
                                    } else {
                                      result.unshift({
                                        // @ts-ignore
                                        url: item?.response?.data
                                          ? item?.response?.data
                                          : item.url,
                                        status: "done"
                                      });
                                    }
                                  }
                                );
                                onChange && onChange(result);
                                let nowlist: Array<any> = [];
                                nowlist = list.filter(
                                  (item) => item.uid !== file.uid
                                );
                                nowlist.unshift(
                                  ...list.filter((item) => item.uid == file.uid)
                                );
                                setFileList(nowlist);
                              }}
                            />
                            <Button
                              type="text"
                              icon={<DeleteOutlined />}
                              onClick={async (e) => {
                                e.stopPropagation();
                                if (
                                  //@ts-ignore
                                  defaultValue?.indexOf(file.path) == -1
                                ) {
                                  Modal.confirm({
                                    title: "提示",
                                    content: "确定删除吗？",
                                    onOk: async () => {
                                      if (
                                        onChange &&
                                        typeof onChange === "function"
                                      ) {
                                        // @ts-ignore
                                        let result: any = [];
                                        list.map(
                                          // @ts-ignore
                                          (item) => {
                                            if (item.uid !== file.uid) {
                                              result.push({
                                                // @ts-ignore
                                                url: item?.response?.data
                                                  ? item?.response?.data
                                                  : item.url,
                                                status: "done"
                                              });
                                            }
                                          }
                                        );
                                        onChange(result);
                                      }
                                      setFileList(
                                        list.filter(
                                          (item) => item.uid !== file.uid
                                        )
                                      );
                                      await API_OTHER.v100001.oss.deleteById({
                                        filePath: file?.response?.data
                                          ? file?.response?.data
                                          : file.url
                                      });
                                    }
                                  });
                                } else {
                                  if (permissions && isPermission) {
                                    Modal.confirm({
                                      title: "提示",
                                      content: "确定删除吗？",
                                      onOk: async () => {
                                        if (
                                          onChange &&
                                          typeof onChange === "function"
                                        ) {
                                          // @ts-ignore
                                          let result: any = [];
                                          list.map(
                                            // @ts-ignore
                                            (item) => {
                                              if (item.uid !== file.uid) {
                                                result.push({
                                                  // @ts-ignore
                                                  url: item?.response?.data
                                                    ? item?.response?.data
                                                    : item.url,
                                                  status: "done"
                                                });
                                              }
                                            }
                                          );
                                          onChange(result);
                                        }
                                        setFileList(
                                          list.filter(
                                            (item) => item.uid !== file.uid
                                          )
                                        );
                                        await API_OTHER.v100001.oss.deleteById({
                                          filePath: file?.response?.data
                                            ? file?.response?.data
                                            : file.url
                                        });
                                      }
                                    });
                                  } else if (permissions && !isPermission) {
                                    notification.info({
                                      message: "提示",
                                      description: "暂无权限,不能删除"
                                    });
                                  } else if (!permissions) {
                                    Modal.confirm({
                                      title: "提示",
                                      content: "确定删除吗？",
                                      onOk: async () => {
                                        if (
                                          onChange &&
                                          typeof onChange === "function"
                                        ) {
                                          // @ts-ignore
                                          let result: any = [];
                                          list.map(
                                            // @ts-ignore
                                            (item) => {
                                              if (item.uid !== file.uid) {
                                                result.push({
                                                  // @ts-ignore
                                                  url: item?.response?.data
                                                    ? item?.response?.data
                                                    : item.url,
                                                  status: "done"
                                                });
                                              }
                                            }
                                          );
                                          onChange(result);
                                        }
                                        setFileList(
                                          list.filter(
                                            (item) => item.uid !== file.uid
                                          )
                                        );
                                        await API_OTHER.v100001.oss.deleteById({
                                          filePath: file?.response?.data
                                            ? file?.response?.data
                                            : file.url
                                        });
                                      }
                                    });
                                  }
                                }
                              }}
                            />
                          </div>
                        )
                      }}
                    />
                  </div>
                </div>
              );
            } else if (file.status == "uploading") {
              return (
                <Spin
                  style={{
                    width: "86px",
                    height: "86px",
                    textAlign: "center",
                    lineHeight: "86px"
                  }}
                />
              );
            } else {
              return (
                <Popover content="上传失败,请删除后重新上传">
                  <Image
                    style={{
                      width: 86,
                      height: 86,
                      border: "1px solid red"
                    }}
                    //@ts-ignore
                    src={
                      "data:image/png;base64,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"
                    }
                    preview={{
                      mask: (
                        <div className="ant-upload-list-item-actions">
                          <Button type="text" icon={<EyeOutlined />} />
                          <Button
                            type="text"
                            icon={<DeleteOutlined />}
                            onClick={async (e) => {
                              e.stopPropagation();
                              if (
                                //@ts-ignore
                                defaultValue?.indexOf(file.path) == -1
                              ) {
                                Modal.confirm({
                                  title: "提示",
                                  content: "确定删除吗？",
                                  onOk: async () => {
                                    if (
                                      onChange &&
                                      typeof onChange === "function"
                                    ) {
                                      // @ts-ignore
                                      let result: any = [];
                                      list.map(
                                        // @ts-ignore
                                        (item) => {
                                          if (item.uid !== file.uid) {
                                            result.push({
                                              // @ts-ignore
                                              url: item?.response?.data
                                                ? item?.response?.data
                                                : item.url,
                                              status: "done"
                                            });
                                          }
                                        }
                                      );
                                      onChange(result);
                                    }
                                    setFileList(
                                      list.filter(
                                        (item) => item.uid !== file.uid
                                      )
                                    );
                                    await API_OTHER.v100001.oss.deleteById({
                                      filePath: file?.response?.data
                                        ? file?.response?.data
                                        : file.url
                                    });
                                  }
                                });
                              } else {
                                if (permissions && isPermission) {
                                  Modal.confirm({
                                    title: "提示",
                                    content: "确定删除吗？",
                                    onOk: async () => {
                                      if (
                                        onChange &&
                                        typeof onChange === "function"
                                      ) {
                                        // @ts-ignore
                                        let result: any = [];
                                        list.map(
                                          // @ts-ignore
                                          (item) => {
                                            if (item.uid !== file.uid) {
                                              result.push({
                                                // @ts-ignore
                                                url: item?.response?.data
                                                  ? item?.response?.data
                                                  : item.url,
                                                status: "done"
                                              });
                                            }
                                          }
                                        );
                                        onChange(result);
                                      }
                                      setFileList(
                                        list.filter(
                                          (item) => item.uid !== file.uid
                                        )
                                      );
                                      await API_OTHER.v100001.oss.deleteById({
                                        filePath: file?.response?.data
                                          ? file?.response?.data
                                          : file.url
                                      });
                                    }
                                  });
                                } else if (permissions && !isPermission) {
                                  notification.info({
                                    message: "提示",
                                    description: "暂无权限,不能删除"
                                  });
                                } else if (!permissions) {
                                  Modal.confirm({
                                    title: "提示",
                                    content: "确定删除吗？",
                                    onOk: async () => {
                                      if (
                                        onChange &&
                                        typeof onChange === "function"
                                      ) {
                                        // @ts-ignore
                                        let result: any = [];
                                        list.map(
                                          // @ts-ignore
                                          (item) => {
                                            if (item.uid !== file.uid) {
                                              result.push({
                                                // @ts-ignore
                                                url: item?.response?.data
                                                  ? item?.response?.data
                                                  : item.url,
                                                status: "done"
                                              });
                                            }
                                          }
                                        );
                                        onChange(result);
                                      }
                                      setFileList(
                                        list.filter(
                                          (item) => item.uid !== file.uid
                                        )
                                      );
                                      await API_OTHER.v100001.oss.deleteById({
                                        filePath: file?.response?.data
                                          ? file?.response?.data
                                          : file.url
                                      });
                                    }
                                  });
                                }
                              }
                            }}
                          />
                        </div>
                      )
                    }}
                  />
                </Popover>
              );
            }
          }}
          listType="picture-card"
          action="/web/other-v100001/oss/upload"
          headers={{
            //@ts-ignore
            token: WebStorageUtil.getItem(`TOKEN-${ReduxActionType.LOGIN}`)
          }}
          onChange={({ file, fileList, event }) => {
            if (onChange && typeof onChange === "function") {
              onChange(
                fileList.map((item: any) => {
                  return {
                    url: item?.response?.data || item.path,
                    status: item?.status
                  };
                })
              );
              setFileList(fileList);
            }
          }}
          {...rest}
        >
          {(list || []).length < 50 && (
            <div style={{ display: "flex" }}>
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>上传</div>
              </div>
            </div>
          )}
        </Upload>
        <div
          className="weixinupload"
          onClick={async () => {
            let time = new Date().getTime().toString(); //获取时间戳
            setSentKey(time);
            try {
              request
                .get(
                  `/sys-v100001/weixinConfig/getUploadImgQr?key=${time}&url=${
                    window.location.protocol +
                    "//" +
                    window.location.hostname +
                    "/wxuplaod.html"
                  }`,
                  {
                    responseType: "blob"
                  }
                )
                .then((res) => {
                  setQrUrl(window.URL.createObjectURL(res.data));
                })
                .catch((err) => {
                  console.log(err);
                });
            } catch (e) {}

            setVisible(true);
          }}
        >
          <PlusOutlined style={{ marginTop: "30px" }} />
          <div style={{ marginTop: 8 }}>微信上传</div>
        </div>
      </Image.PreviewGroup>
      <Modal
        visible={visible}
        title="微信上传"
        onCancel={async () => {
          setVisible(false);
        }}
        confirmLoading={confirmLoading}
        onOk={async () => {
          setConfirmLoading(true);
          try {
            let res =
              await API_SYS.v100001.weixinConfig.getWeiXinServerIdImgUrl({
                key: sentKey
              });
            if (!res.data.code) {
              console.log(res.data.data);
              //@ts-ignore
              let newImg = res.data.data.split(",").map((item) => {
                return {
                  url: item,
                  status: "done"
                };
              });
              onChange && onChange([...value, ...newImg]);
              setVisible(false);
              setConfirmLoading(false);
            }
          } catch (e) {
            setConfirmLoading(false);
          }
        }}
      >
        <div className="qrstyle">
          <Image src={qrUrl} preview={false} />
        </div>
      </Modal>
    </>
  );
}

function getBase64(file: any): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export interface UploadImageProps
  extends Omit<CurrencyUploadProps, "onChange"> {
  value?: valueType[];
  onChange?: (value: valueType[]) => valueType[];
  permissions?: string[];
  defaultValue?: string[];
}
interface valueType {
  url: string;
  status: string;
}
